import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const prescribersService = {
   getAllPrescribers: (companyId, position) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TOP_PRESCRIBERS}?position=${position}`);
    },
};

export default prescribersService;